(function() {
  'use strict';
  angular.module('benefits')
  .filter('ageLimitation', ['benefitService', function(benefitService) {
    return function(category, benefitInfo) {
      return benefitService.ageLimitation(category, benefitInfo);
    };
  }]);
})();
